export default __webpack_public_path__ + "static/media/rps.82b0b5aa.ico";